export default {
  paymentList: state => state.paymentList
}
